import {Component, Input} from '@angular/core';

@Component({
  selector: 'flipcard',
  templateUrl: 'flipcard.html',
  styleUrls: ['flipcard.scss'],
})

export class FlipCardComponent {

  public _flipped = false;
  public _flipVis = false;

  constructor() {}

  @Input() public set flipped(flipped: boolean) {
    if ( flipped != this._flipped ) {
      this._flipped = flipped;
      setTimeout(() => { this._flipVis = this._flipped; }, 400);
    }
  }

}
